import { SUCCESS, FAIL, GET_DOCKETS } from "../action_types";

const STATE_INIT = {
  isLoading: false,
  dockets: [],
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_DOCKETS:
      return { ...state, isLoading: true };
    case `${GET_DOCKETS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        dockets: [...payload],
      };
    case `${GET_DOCKETS}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    default:
      return state;
  }
};
